export default __webpack_public_path__ + "static/media/logo192.a025b164.png";